import React from "react";
import { TextField, FormControl } from "@mui/material";
import { styled } from "@mui/system";
const FormParent = styled(FormControl)({
  marginBottom: 24,
  fieldset: {},
  "& .MuiFormLabel-asterisk": {
    color: "#000000",
  },
  "& .MuiFormLabel-root": {
    color: "#666666",
    "&.Mui-focused": {
      color: "#3BB8E0",
    },
  },
  "& .MuiInputBase-input": {
    borderRadius: "0px",
    font: 'inherit',
    color:"#707070",
    fontSize:"14px"
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "0px",
    "&.Mui-disabled": {
      opacity: 0.5,
      "& fieldset": {
        borderColor: "#666666",
        opacity: ".5",
      },
      "&:hover fieldset": {
        opacity: ".5",
        borderColor: "#666666",
      },
      "& img": {
        opacity: ".5",
        cursor: "default",
      },
    },
    "& fieldset": {
      borderRadius: "4px",
      border: "1px solid #666666",
    },
    "&:hover fieldset": {
      borderColor: "#3BB8E0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#3BB8E0",
    },
  },
});
const CustomInput = styled(TextField)({});
const Input = ({
  label,
  type="text",
  error,
  className,
  required,
  placeholder,
  disabled,
  multiline,
  prefix,
  suffix,
  minRows,
  startAdornment = null,
  endAdornment = null,
  onChange,
  value,
  wrapperClass,
  readOnly=false,
  size
}) => {
  const isRTL = document.dir === "rtl";
  return (
    <>
      <FormParent fullWidth className={wrapperClass}>
      {!!prefix && prefix}
        <CustomInput
          id="outlined-basic"
          type={type}
          className={`${className} ${value?'is-value-exist':''} ${isRTL ? "rtl" : ""}`}
          required={required}
          disabled={disabled}
          label={label}
          placeholder={placeholder}
          multiline={multiline}
          minRows={minRows}
           size={size}
          variant="outlined"
          value={value || ""}
          InputProps={{
            readOnly:readOnly,
            ...(startAdornment && { startAdornment }),
            ...(endAdornment && { endAdornment }),
            className: isRTL ? "rtl" : "",
          }}
          onChange={onChange}
        />
         {!!suffix && suffix}
        {error? (
          <span className="text-[12px] text-red-400 font-nunitoregular">
            {error}
          </span>
        ):null}
      </FormParent>
    </>
  );
};

export { Input };
